




import Vue from "vue"
import Auth from "~/components/custom/auth/Auth.vue"

export default Vue.extend({
  components: {
    Auth,
  },
  head(): object {
    return this.$clHelpers.metaTag.generate({
      title: "認証中...",
      currentPath: this.$nuxt.$route.path,
      disableTitleTemplate: true,
    })
  },
})
